let NODE_ENV = window.XINPOC_DISPATCH_CONFIG.isProject;
let title = {
  towway: "two way direct",
  HPYJ: "HPYJ 調度平台",
  yuantong: "調度台",
  chunsheng: "調度台",
  TALK2ME: "Web調度程式平台",
  wanlian: "CAC調度台",
  EuroNews:"WOUXUN Global",
  quansheng:"QUESUM",
};
let voice_title = {
  XiamenGuanhe:"對講平台，用心服務，讓對講更有效率",
  wanlian: "您的安全，我們關注",
}
let conpanyname = {
  chunsheng:"Copyright © 2025 Poclink Radios. All Rights Reserved.",
  XiamenGuanhe:"觀合通訊科技（廈門）有限公司",
  TALK2ME: "Talk2Me Social Inc. (832)880-0000",
  wanlian: "CONGO ASTRAL COMPANY",
  EuroNews: "WOUXUN COMMUNICATIONS LIMITED",
}

let versions = {
  EuroNews:'V1.00.00'
}

module.exports = {
  language: {
    name: '中文（繁體）',
    title: '語言',
  },

  about: {
    title: title[NODE_ENV] || '全球對講調度台',
    conpanyname: conpanyname[NODE_ENV] || '深圳市博納德資訊科技有限公司',
    version:versions[NODE_ENV] || "v1.6.2"
  },
  login: {
    account: '輸入登入帳號',
    password: '輸入密碼',
    installationServices: '安裝語音服務',
    rememberme: '記住帳號',
    Login: '登入'
  },
  message: {
    loginAccountTips: '登入帳號不能為空',
    loginPasswordTips: '密碼不能為空',
    usernamePasswordTips: '帳號或密碼錯誤',
    loginsuccessful: '登入成功',
    accountNumbers: '帳號只能輸入數字!',
    noDispatcher: '登入失敗該帳號不是調度員!',
    accountNotpresent: '帳號不存在!',
    LoginAbnormal: '登入異常請重試!',
    voiceServiceNotInstalled: '請安裝語音服務若安裝請刷新瀏覽器！',
    Videocallinprogress: '正在視訊呼叫！',
    Voicecallinprogress: '正在語音通話！',
    Youhavebeenclosedforspeaking: '您已被關閉發言！ ',
    tctemporarygroup: '確認刷新並退出臨時群組嗎？ ',
    Doyouwanttologout: '是否登出登入?',
    prompt: '提示',
    Nonetworklink: '無網頁連結',
    deletedGro: '此群組已被刪除無法操作！',
    Pleaseselectthedesired: '請選擇需要',
    deletedGroUsers: '的用戶！',
    Voicecallfunction: '請先在管理平台開啟語音通話功能！',
    Alreadytemporary: '已在臨時群組無法呼叫!',
    Onlysupports: '只支援對單一用戶發起語音通話!',
    Enablevoicecalls: '此用戶未在管理平台開啟語音通話功能！',
    Oncall: '正在通話中無法創建！',
    Shaketodeath: '搖斃中不可創建',
    Shaketodeath2: '搖斃中不可切換群組',
    createregiongroups: '最多只能建立3個區域群組!',
    temporarygroupsnoadd: '已在臨時群組無法建立！',
    haleDispatcherGroupUser: '只能強拉調度員所在群組的成員',
    TemporaryGroupNoHale: '臨時群組不可強拉！ ',
    Groupcallfailure: '組呼失敗',
    Exitsuccessfully: '退出成功!',
    Usernotonline: '用戶不在線!',
    Theotherpartyisbusy: '對方忙線中！',
    Callfailed: '呼叫失敗！',
    Theotherpartyhashungup: '對方已掛斷！',
    Networkconnectionfailed: '網路連線失敗清稍後重試',
    Callended: '通話結束！',
    Accountpassworderror: '帳號密碼錯誤',
    Arrears: '欠費',
    Accountdoesnotexist: '帳號不存在',
    Permissionerror: '權限錯誤',
    AccountInfoChange: '帳號資訊已變更',
    Configuration: '設定資訊錯誤',
    accountOtherlogins: '帳號已在其他地方登入！',
    Accountlogintimeout: '帳號登入逾時',
    Networkconnectionfailure: '⽹絡連線失敗',
    Thenetworkisreconnecting: '⽹絡正在重連',
    Addinggroupfailed: '加⼊群組失敗',
    Addgrouprequesttimeout: '加⼊群組請求超時',
    Singlecallfailure: '單呼失敗',
    Failedtojointhegroup: '加入群組失敗[權限錯誤]',
    Failedtojointhegroup2: '加入群組失敗[不存在]',
    Failedtojointhegroup3: '加入群組失敗[過期]',
    Failedtojointhegroup4: '加入群組失敗[配額限制]',
    Failedtojointhegroup5: '加入群組失敗[有效的物件為空]',
    noSnatchingwheat: '加入群組失敗[有效的物件為空]',
    noRemoteclosureSnatchingwheat: '遙閉狀態搶麥不允許',
    Failedtograbthewheat: '搶麥時申請音頻焦點失敗',
    Grabbingwheattimeout: '接收搶麥回應超時',
    Failedtoopenrecordingdevice: '開啟錄音設備失敗',
    Accountlocked: '帳號被鎖定',
    Terminallocked: '終端被鎖定',
    Machinecardlocked: '機卡被鎖定',
    Noaccountinformationconfigured: '沒有配置帳號資訊',
    Successfullysaved: '保存成功!',
    Successfullysethost: '設定主持人成功!',
    Successfullydeleted: '刪除成功!',
    Successfullyadded: '添加成功！',
    Successfullyremoved: '移除成功！',
    update_successfully: '更新成功',
    Successfullymodified: '修改成功！',
    oldpassworderror: '舊密碼錯誤',
    Parametererror: '參數錯誤',
    Pleaseselecttheuseryouwanttoadd: '請選擇需要新增的用戶！',
    Addingfailed: '新增失敗不在群組使用者清單為空！',
    Pleaseselectuserremoved: '請選擇需要移除的使用者！',
    Removalfailed: '移除失敗在群組使用者清單為空！',
    Prioritysetsuccessfully: '優先級設定成功',
    Pleaseselectastartandendtime: '請選擇開始和結束時間',
    endTimeNoStarttime: '結束時間不能早於開始時間',
    Thestartandendtimesmustbeonthesameday: '開始時間和結束時間必須為同一天',
    RedefineCustomization: '自訂區域點數少於3個請重新劃!',
    Unabletocreatetemporarygroup: '暫無線上成員無法建立臨時群組！',
    Pleaseenteroldpassword: '請輸入舊密碼',
    Pleaseenteranewpassword: '請輸入新密碼',
    Confirmnewpassword: '確認輸入新密碼',
    noSamePassword: '舊密碼與新密碼不能一致！',
    noSamePasswordTow: '兩次輸入密碼不一致!',
    pleaseenterpasswordagain: '請再次輸入密碼',
    Successfullyprocessed: '處理成功',
    voice_title: voice_title[NODE_ENV] || ""
  },
  search: '搜尋',
  users: '使用者',
  refund: '返回',
  Loadingdesperately: '拼命載入中',
  Speaking: '正在講話...',
  Iamspeaking: '我正在講話...',
  communicatebytelephone: '通話',
  call: '呼叫',
  hale: '強拉',
  Forceddemolition: '強拆',
  confirm: '確定',
  cancel: '取消',
  dispatchIntercom: '調度對講',
  allGroups: '全部群組',
  fixedGroup: '固定群組',
  regionalGroup: '區域群組',
  filter: '篩選',
  all: '全部',
  online: '網路',
  offline: '離線',
  groupUser: '群組/用戶',
  enter: '進入',
  edit: '編輯',
  voiceIntercom: '語音對講',
  baseStationSwitch: '基地台開關',
  gpsSwitch: 'GPS開關',
  viewHistoricalTrack: '查看歷史軌跡',
  startingtime1: '起始時間',
  selectionPeriod: '選擇時間',
  startingTime: '開始時間',
  Pleaseselectadateandtime: '請選擇開始時間',
  EndTime: '結束時間',
  Pleaseselectanendtime: '請選擇結束時間',
  selectDate: '選擇日期',
  SelectStartTime: '選擇開始時間',
  Now: '此刻',
  Sure: '確定',
  Closure: '關閉',
  editArea: '修改區域',
  deleteArea: '刪除區域',
  Areyousuretosavethefence: '確定要保存圍籬嗎？',
  deleteLocalgroup: '確定要刪除區域群組嗎？',
  pleaseselectaregion: '請先圈選圍籬區域！',
  doubleclicktocreate: '按兩下創建',
  doubleclick: '按兩下',
  Createregionalgroups: '建立區域群組',
  groupName: '群組名稱',
  Pleaseenterthegroupname: '請輸入群組名稱',
  pleaseenteragroupname: '請輸入群組名稱（由2-15位數字中文英文組成）',
  groupnameTips: '群組名稱由2-15位數中文英文組成',
  pleaseenteragroupnameTips: '由2-15位數字中文英文組成',
  selectGroup: '選擇群組',
  Pinnedingroupusers: '固定在群組用戶',
  TemporaryGroup: '臨時在群組用戶',
  Usernotingroup: '不在群組用戶',
  userImei: '使用者/IMEI',
  Pleaseselectauser: '請選擇用戶',
  Create: '創建',
  Cancel: '取消',
  groupEdit: '群組編輯',
  usersingroup: '在群組用戶',
  UsernameImei: '使用者名稱/IMEI',
  userName: '使用者名稱',
  noData: '暫無數據',
  removeselectedusers: '移除選取的用戶',
  Removeall: '全部移除',
  Addtheselecteduser: '新增選取的用戶',
  Addall: '全部添加',
  Save: '儲存',
  selectUser: '選擇用戶',
  Edittakeseffect: '编辑即生效',
  UserManagement: '使用者管理',
  Userpriority: '使用者優先級',
  levelone: '一級',
  Secondary: '二級',
  Levelthree: '三級',
  Levelfour: '四級',
  Fifthgrade: '五級',
  Editstakeeffectimmediately: '編輯立即生效',
  Setmoderator: '設定主持人',
  SelectHost: '選擇主持人',
  Host: '主持人',
  Pleasechoose: '請選擇',
  Deletemoderator: '刪除主持人',
  Setuphost: '只能設定一個用戶為主持人',
  Pleaseselectacall: '請選擇需要通話的內容',
  Waitingforanswering: '等待對方接聽語音',
  Inviteyoutovoicecall: '邀請你語音通話',
  callingusers: '請選擇需要呼叫的用戶',
  Forcedpullusers: '請選擇需要強拉的用戶',
  Forceddismantlingusers: '請選擇需要強拆的用戶',
  SearchLocation: '搜地點',
  Show: '顯示',
  Hide: '隱藏',
  Default: '預設',
  Satellite: '衛星',
  Roadconditions: '路況',
  Toolbox: '工具箱',
  Ranging: '測距',
  Mark: '標記',
  Broadcast: '廣播',
  EnableBroadcastGroup: '請先開啟接收廣播的群組',
  textBroadcast: '文字廣播',
  Hasbeensent: '已發送',
  textBroadcastContent: '請輸入文字廣播內容（不超過50字）',
  pleaseentertextbroadcast: '請輸入文字廣播',
  Send: '傳送',
  voiceBroadcast: '語音廣播',
  Clicktorecordvoicebroadcast: '點選錄製語音廣播',
  Pleaserecordthevoicebroadcast: '請錄製語音廣播',
  RecordingTime: '錄音時間不能少於1秒',
  Broadcaster: '廣播人',
  BroadcastTime: '廣播時間',
  listento: '收聽',
  Warningmessage: '告警訊息',
  AlarmHistory: '更多警告訊息請查看歷史記錄',
  Name: '名稱',
  Address: '地址',
  Time: '名稱',
  Check: '查看',
  State: '狀態',
  Unprocessed: '未處理',
  DealWith: '處理',
  delete: '刪除',
  PTTbuttondisplay: 'PTT按鍵顯示',
  SOSalarmsound: 'SOS警報聲音',
  Fencealarmsound: '圍籬警告聲音',
  Motiontrajectorybinding: '運動軌跡綁路',
  Changepassword: '修改密碼',
  Logoutoflogin: '登出登入',
  Dataanalysis: '數據分析',
  Statisticstoday: '今日統計',
  Currentonlineusers: '當下線上用戶數',
  Totalnumberofusers: '用戶總數',
  Fencerecord: '圍欄記錄',
  SOSrecord: 'SOS記錄',
  recordingrecord: '錄音記錄',
  Grouponlineusers: '群組線上用戶',
  Comparison: '7天線上用戶數對比',
  warningcomparison: '30天預警對比',
  Fencewarning: '圍籬預警',
  SOSwarning: 'SOS預警',
  OldPassword: '舊密碼',
  NewPassword: '新密碼',
  ConfirmPassword: '確認密碼',
  consists: '由6-16位字母數字組成',
  startingpoint: '起點',
  totallength: '總長',
  ico: '圖示',
  date: '日期',
  Targeting: '定位方式',
  Basestationpositioning: '基地台定位',
  BeidouGPS: '北斗/GPS',
  direction: '方向',
  altitude: '海拔',
  Speed: '速度(KM/H)',
  warmreminder: '小提醒：數據來自第三方會存在誤差僅供參考。',
  Iconselection: '圖示選擇',
  pleaseentername: '請輸入名稱',
  changeicon: '更換圖示',
  Universal: '一般',
  policesecurity: '警保',
  Firefighting: '消防',
  Chemicalindustry: '化工',
  other: '其他',
  save: '儲存',
  close: '關閉',
  viewtag: '查看標記',
  addtag: '添加標記',
  Supportsaddingamaximum: '最大支援添加10個圖標',
  Imageformaterror: '圖片格式錯誤',
  uploadedimage: '上傳圖片大小不能超過5kb',
  uploadsuccessful: '上傳成功',
  uploadfailed: '上傳失敗',
  uploadfailedimage: '上傳失敗：圖片最大支援像素25×25！',
  Successfuloperation: '操作成功',
  operationfailed: '操作失敗',
  Editmark: '編輯標記',
  Pleaseselecttheiconyouwanttodelete: '請選擇需要刪除的圖標',
  successfullydeleted: '刪除成功',
  failedtodelete: '刪除失敗',
  north: '北',
  South: '南',
  West: '西',
  East: '東',
  truenorth: '正北',
  duesouth: '正南',
  duewest: '正西',
  Zhengdong: '正東',
  partial: '偏',
  historyrecord: '歷史記錄',
  group: '群組',
  pleaseselectagroup: '請選擇群組',
  sender: '送出人',
  Pleaseselectuser: '請選擇用戶',
  Sendtime: '發送時間',
  startrange: '開始範圍',
  endrange: '結束範圍',
  startdate: '開始日期',
  Startingtime: '開始時間',
  enddate: '結束日期',
  to: '至',
  Clear: '清空',
  Confirm: '確定',
  state: '狀態',
  Pleaseselectastatus: '請選擇狀態',
  Processed: '已處理',
  Processor: '處理人',
  processtime: '處理時間',
  serialnumber: '序號',
  operate: '操作',
  ViewSOSlocation: '查看SOS位置',
  Back: '返回',
  Warmreminder: '小提醒：資料來源第三方會存在誤差僅供參考',
  SOSalarmsintemporarygroupsarenotrecorded: '臨時群組中的SOS告警不做記錄',
  Pleaseselectatype: '請選擇類型',
  deleted: '已刪除',
  next: '下一條',
  Tobeprocessed: '待處理',
  dealwith: '處理',
  alreadydispatched: '已被調度員',
  temporarygroup: '臨時群組',
  NortheasternHemisphere: '東北半球',
  northwesternhemisphere: '西北半球',
  SoutheasternHemisphere: '東南半球',
  southwesternhemisphere: '西南半球',
  Nolocationtrack: '沒有位置軌跡',
  Latitudeandlongitude: '經緯度',
  Reportingtime: '上報時間',
  Positioningtime: '定位時間',
  Alarminformation: '告警訊息',
  AlarminformationTips: '更多警告訊息請查看歷史記錄',
  initiatesos: '發起sos',
  Forcedvideo: '強拉視頻',
  videocall: '視訊呼叫',
  Videopostback: '影片回傳',
  leave: '離開',
  Enter: '進入',
  fence: '圍欄',
  newgroup: '新群組',
  Joingroup: '加入群组',
  Thegroupnamealreadyexistspleasereenterit: '群組名稱已存在請重新輸入',
  Groupcreatedsuccessfully: '群組創建成功',
  Groupcreationfailedpleasecreateagain: '群組建立失敗請重新建立！',
  Pleaseenterthegrouppassword: '請輸入群口令',
  Thegrouppasswordyouenterediswrong: '您輸入的群組口令錯',
  Grouppassword: '群口令',
  Dissolve: '解散',
  Exit: '退出',
  Disbandselforganizedgroup: '解散自建組',
  Exittheselfcreatedgroup: '退出自建組',
  ExiDissolvetheselfestablishedgroupt: '確定要解散自建組嗎？',
  Exitselfbuiltgroup: '確定要退出該自建組嗎？',
  Grouptransfer: '群主轉讓',
  Theusersselfbuiltgroupfunctionisnotopened: "用戶自建群組功能未開啟",
  Createfence: '創建圍欄',
  Editfence: '編輯圍欄',
  electricfence: '電子圍欄',
  Electronicfencelist: '電子圍籬列表',
  fencename: '圍欄名稱',
  efficient: '有效',
  Invalid: '失效',
  Forbidden: '禁出',
  Noentry: '禁入',
  Pleasesearchorselfselectthefencedareafirst: '請先圈選圍籬區域！',
  Areyousureyouwanttodeletetheelectronicfence: '確定要刪除電子圍籬嗎',
  Triggermode: '觸發方式',
  timesetting: '時間設定',
  Pleaseenterthefencename: '請輸入圍籬名稱',
  tipsItconsists: '由1-15位中文數字字母底線組成且不能以下劃線開頭',
  tipsItconsistsName: '圍籬名稱由1-15位中文數字字母底線組成且不能以下劃線開頭',
  Pleaseselectamethodofentryandexit: '請選擇出入方式!',
  Pleaseselectatleastoneday: '請至少選擇一天',
  Notinfenceusers: '不在圍欄用戶',
  Usersonthefence: '在圍欄用戶',
  Validdate: '有效日期',
  Validperiod: '有效時段',
  Selecttimerange: '選擇時間範圍',
  Monday: '週一',
  Tuesday: '週二',
  Wednesday: '週三',
  Thursday: '週四',
  Friday: '週五',
  Saturday: '週六',
  Sunday: '週日',
  Createdsuccessfully: '創建成功',
  Thefencenameisduplicated: '圍籬名稱重複請修改後重試',
  Ifnotselected: '不選擇預設永久有效',
  FenceEdit: '圍籬編輯',
  Removalfailedfence: '移除失敗在圍欄用戶列表為空！',
  Failedtoaddfence: '新增失敗不在圍欄用戶列表為空！',
  Outofboundsrecord: '越界記錄',
  Outofboundstype: '越界類型',
  Pleaseselectausername: '請選擇使用者名稱',
  Pleaseselecttriggermethod: '請選擇觸發方式',
  Crossborderdate: '越界日期',
  currentrecord: '目前記錄',
  Triggertime: '觸發時間',
  Pleaseselectafencename: '請選擇圍籬名稱',
  Releasetime: '解除時間',
  Batchdownload: '大量下載',
  Recordingplayback: '錄音播放',
  download: '下載',
  Areyousureyouwant: '確定下載所選的錄音嗎?',
  Record: '記錄',
  Pleaseselecttherecording: '請選擇要下載的錄音記錄',
  downloadsuccessful: '下載成功',
  Voiceaudio: '語音音訊',
  text: '文字',
  voice: '語音',
  Doubleclicktocreate: '按兩下創建',
  Doubleclicktosave: '按兩下儲存',
  outofboundsperson: '越界人',
  temporarygroupTow: '臨時群組',
  Theotherpartyhasnoanswer: '對方無應答！',
  sosrecord: 'SOS歷史記錄',
  UnhandledSOSexists: '存在未處理的SOS',

  RealTimeVideo: '即時視訊',
  ForceVideo: '強拉影片/影片回傳',
  VideoCall: '視訊呼叫',
  CurrentlyNoRealTimeVideo: '目前沒有即時視訊',
  VideoUserList: '視訊使用者列表',
  Filter: '篩選: ',
  All: '全部',
  Online: '網路',
  Offline: '離線',
  GroupUser: '群組/用戶',
  ForceVideos: '強拉視頻',
  PleaseSelectTheUserWhoNeedsxxx: '請選擇用戶！',
  TheDispatcherCannotForceIt: '調度員不可強拉！',
  VoiceCallInProgress: '正在語音通話！',
  PleaseActivateTheVideoServiceAndVideoCallFunctionOnTheManagementPlatformFirst: '請先在管理平台開立視訊服務並開啟視訊通話功能！',
  PleaseEnableTheVideoCallFunctionOnTheManagementPlatformFirst: '請先在管理平台開啟視訊通話功能！',
  UserIsNotOnline: '用戶不在線',
  OnlySupportsInitiatingVideoCallsToASingleUser: '只支援對單一用戶發起視訊呼叫',
  ThisUserHasNotActivatedTheVideoServiceOnTheManagementPlatform: '此用戶未在管理平台開設視訊服務！',
  ThisUserHasNotEnabledTheVideoCallFunctionOnTheManagementPlatform: '此用戶未在管理平台開啟視訊通話功能！',
  VideoCallInProgress: '正在視訊通話!',
  CannotCallTheTerminalThatIsTransmittingVideo: '不能單呼正在回傳視訊的終端',
  TheOtherPartyIsBusy1: '對方忙',
  ThisUserHasNotEnabledTheForceVideoFunctionOnTheManagementPlatform: '此用戶未在管理平台開啟強拉影片功能！',
  CannotForceTheTerminalThatIsTransmittingVideo: '不能強拉正在回傳視訊的終端',
  UserAlreadyExists: '用戶已存在',

  TheOtherPartyInvitedMeToAVideoCall: '對方邀請視訊呼叫...',
  Connecting: '連接中...',
  TheOtherPartyHasRejected: '對方已拒絕',
  TheOtherPartyHasHungUp: '對方已掛斷',
  TheOtherPartyDidNotAnswer: '對方未接聽',
  TheOtherPartyIsBusy2: '對方忙線!',
  ConnectionInterruptedCallEnded: '連線中斷,通話結束!',
  AnswerFailed: '接聽失敗',
  ConnectionFailed: '連線失敗',
  exceedFenceMsg:'已超過最大創建數，請刪除圍欄後重試',

  userPatrol: {
    searchLable: {
        PlanName: "計劃名稱",
        PatrolUsers: "巡更用戶",
        ExecutionResult: "執行結果",
        PatrolTime: "巡更時間",
        PatrolPointName: "巡更點名稱",
    },
    placeholder: {
        PleaseEnterThePlanMame: "請輸入計劃名稱",
        PleaseEnterThePatrolUser: "請輸入巡更用戶",
        PleaseSelectTheExecutionResult: "請選擇執行結果",
    },
    tableHeader:{
        PlanName: "計劃名稱",
        patrolPoint: "巡更點",
        PatrolUsers: "巡更用戶",
        PatrolPointName:"巡更點名稱",
        StartTime: "開始時間",
        EndTime: "結束時間",
        ExecutionResult: "執行結果",
        type:"類型",
        PatrolTime:"巡更時間",
    },
    status: {
        NotStarted:"未開始",
        InProgress: "進行中",
        Completed: "已完成",
        MissingPatrol: "漏巡",
        positioning: "定位",
        NFC:"NFC",
        Bluetooth: "藍牙",
    },
    StartingRange: "開始範圍",
    EndRange: "結束範圍",
    ViewDetails:"看詳情",
    PatrolTrajectory: "巡更軌跡",
    patrol:'巡更',
    PatrolFailed:"巡更失敗",
    PatrolLog: "巡更記錄",
  }
};